import { createSignal } from '@funtech-int/rival';
import { useEffect, useMemo } from 'react';

export function useTimeSignal(interval: number) {
    const controller = useMemo(() => {
        const timeSignal = createSignal(Date.now());

        return {
            timeSignal: timeSignal.seal(),
            init() {
                const time = setInterval(() => {
                    timeSignal.set(Date.now());
                }, interval);

                return () => clearInterval(time);
            },
        };
    }, [interval]);

    useEffect(() => controller.init(), [controller]);

    return controller.timeSignal;
}
